<template>
    <div class="ui-page">
        <ui-page-header title="Notícias" subtitle="Notícias exibidas na aba Notícias da página de cada caso no site.">
            <v-btn id="btnNew" color="primary" depressed :disabled="!$check('ClientNews', 'POST')" @click="openDialog()">
                <v-icon left small>mdi-plus</v-icon>
                Incluir
            </v-btn>
        </ui-page-header>

        <ui-table-card clearable :can-clear="hasFilters" @clear="clearFilters">
            <template #toolbar>
                <v-text-field id="title" v-model="dataList.filter.title" placeholder="Buscar pelo título" prepend-inner-icon="mdi-magnify"
                    dense outlined hide-details class="ui-toolbar__search" @input="filterDebounced" @keyup.enter="applyFilters"></v-text-field>
                <v-autocomplete id="client" v-model="dataList.filter.client_id" :items="clients" item-text="name" item-value="id"
                    placeholder="Todos os casos" dense outlined hide-details clearable class="ui-toolbar__field"
                    no-data-text="Nenhum caso encontrado" @change="applyFilters"></v-autocomplete>
            </template>

            <v-data-table :headers="dataList.headers" :items="dataList.data" :server-items-length="dataList.count"
                :options.sync="dataList.options" :loading="dataList.loading" disable-sort hide-default-footer
                no-data-text="Nenhuma notícia foi encontrada" loading-text="Carregando dados..." class="ui-clickable-rows"
                @click:row="openRow">
                <template v-slot:[`item.published_at`]="{ item }">
                    {{ $moment(item.published_at).format('DD/MM/YYYY') }}
                </template>

                <template v-slot:[`item.title`]="{ item }">
                    <span class="ui-cell-main">{{ item.title }}</span>
                </template>

                <template v-slot:[`item.image_url`]="{ item }">
                    <v-img v-if="item.image_url" :src="item.image_url" width="64" height="40" class="rounded" cover></v-img>
                    <span v-else class="ui-muted">—</span>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                    <ui-row-actions :actions="[
                        { text: 'Editar', icon: 'mdi-pencil-outline', disabled: !$check('ClientNews', 'PATCH'), handler: () => openDialog(item) },
                        { text: 'Excluir', icon: 'mdi-delete-outline', danger: true, disabled: !$check('ClientNews', 'DELETE'), handler: () => deleteItem(item) },
                    ]" />
                </template>
            </v-data-table>

            <template #footer>
                <ui-pagination :total="dataList.count" :page="dataList.options.page" :items-per-page="dataList.options.itemsPerPage"
                    :disabled="dataList.loading" @update:page="pageChanged" @update:itemsPerPage="setPageSize" />
            </template>
        </ui-table-card>

        <!-- Cadastro: escolhe o caso e informa titulo, data, imagem e texto -->
        <v-dialog v-model="dialog.open" max-width="860px" persistent scrollable>
            <v-card class="ui-card">
                <div class="ui-card__header">
                    <h3 class="ui-section-title">{{ dialog.editing ? 'Editar notícia' : 'Nova notícia' }}</h3>
                    <v-btn icon small @click="dialog.open = false"><v-icon>mdi-close</v-icon></v-btn>
                </div>
                <div class="ui-card__body">
                    <v-row dense>
                        <v-col cols="12">
                            <v-autocomplete v-model="dialog.form.client_id" :items="clients" item-text="name" item-value="id"
                                label="Caso *" outlined dense hide-details="auto" :disabled="!!dialog.editing"
                                no-data-text="Nenhum caso encontrado"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-text-field v-model="dialog.form.title" label="Título *" outlined dense hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="dialog.form.published_at" label="Data *" type="date" outlined dense hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input v-model="dialog.imageFile" label="Imagem (opcional)" accept="image/*" outlined dense
                                prepend-icon="" append-icon="mdi-image-outline" hint="JPG ou PNG, até 10 MB" persistent-hint hide-details="auto"></v-file-input>
                            <div v-if="dialog.editing && dialog.editing.image_url && !dialog.imageFile && !dialog.removeImage" class="d-flex align-center mt-2" style="gap: 12px;">
                                <v-img :src="dialog.editing.image_url" max-width="160" max-height="100" class="rounded" contain></v-img>
                                <v-btn v-if="$allowed('delete')" x-small text color="error" @click="dialog.removeImage = true">Remover imagem atual</v-btn>
                            </div>
                            <div v-else-if="dialog.removeImage" class="text-caption ui-muted mt-2">A imagem atual será removida ao salvar.</div>
                        </v-col>
                        <v-col cols="12">
                            <p class="font-weight-bold mb-1">Texto</p>
                            <tiptap-vuetify v-model="dialog.form.content" :extensions="extensions" placeholder="Escreva a notícia..." />
                        </v-col>
                    </v-row>
                </div>
                <div class="ui-card__footer">
                    <v-btn text @click="dialog.open = false">Cancelar</v-btn>
                    <v-btn v-if="$allowed('save')" color="primary" depressed :loading="dialog.saving" @click="save()">
                        {{ dialog.editing ? 'Salvar' : 'Publicar' }}
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import {
    TiptapVuetify, Bold, Italic, Strike, Underline, Paragraph, Link, BulletList, OrderedList, ListItem
} from 'tiptap-vuetify'

Vue.use(VueLodash)

export default {
    name: "ClientNewsList",

    components: {
        'tiptap-vuetify': TiptapVuetify,
    },

    data: () => ({
        clients: [],
        extensions: [Underline, Strike, Italic, Bold, Paragraph, Link, BulletList, OrderedList, ListItem],
        dialog: {
            open: false,
            saving: false,
            editing: null,
            imageFile: null,
            removeImage: false,
            form: { client_id: null, title: '', published_at: '', content: '' },
        },
        dataList: {
            filter: {
                title: "",
                client_id: null,
            },
            headers: [
                { text: "Data", value: "published_at", width: 120 },
                { text: "Caso", value: "client_name" },
                { text: "Título", value: "title" },
                { text: "Imagem", value: "image_url", width: 90 },
                { text: "Cadastrada por", value: "admin_name" },
                { text: '', value: 'actions', sortable: false, align: 'end', width: 56 },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
            },
        },
    }),

    computed: {
        hasFilters() {
            return Boolean(this.dataList.filter.title) || !!this.dataList.filter.client_id;
        },
    },

    created() {
        this.loadClients();
        this.load();
    },

    methods: {
        applyFilters() {
            this.dataList.options.page = 1;
            this.load();
        },

        filterDebounced: _.debounce(function () {
            this.applyFilters();
        }, 400),

        clearFilters() {
            this.dataList.filter = { title: "", client_id: null };
            this.applyFilters();
        },

        // A troca de tamanho e seguida de update:page(1), que recarrega.
        setPageSize(size) {
            this.dataList.options.itemsPerPage = size;
        },

        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        async loadClients() {
            try {
                const result = await axios.get(`/api/clients`, { params: { limit: 10000000 } });
                const data = result.data.content.data || [];
                data.sort((a, b) => a.name.localeCompare(b.name));
                this.clients = data;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
            }
        },

        async load() {
            this.dataList.loading = true;
            try {
                const search = {};
                if (this.dataList.filter.title) search.title = this.dataList.filter.title;
                if (this.dataList.filter.client_id) search.client_id = this.dataList.filter.client_id;

                const result = await axios.get('/api/admin/client-news', {
                    params: { page: this.dataList.options.page, limit: this.dataList.options.itemsPerPage, search: JSON.stringify(search) }
                });
                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
            } finally {
                this.dataList.loading = false;
            }
        },

        openRow(item) {
            if (this.$check('ClientNews', 'GET')) this.openDialog(item);
        },

        openDialog(item = null) {
            this.dialog.editing = item;
            this.dialog.imageFile = null;
            this.dialog.removeImage = false;
            this.dialog.form = item
                ? { client_id: item.client_id, title: item.title, published_at: item.published_at || '', content: item.content || '' }
                : { client_id: this.dataList.filter.client_id || null, title: '', published_at: this.$moment().format('YYYY-MM-DD'), content: '' };
            this.dialog.open = true;
        },

        async save() {
            const form = this.dialog.form;
            if (!form.client_id) {
                this.$dialog.notify.warning('Selecione o caso', { position: 'top-right', timeout: 2000 });
                return;
            }
            if (!String(form.title || '').trim()) {
                this.$dialog.notify.warning('Informe o título da notícia', { position: 'top-right', timeout: 2000 });
                return;
            }
            if (!form.published_at) {
                this.$dialog.notify.warning('Informe a data da notícia', { position: 'top-right', timeout: 2000 });
                return;
            }

            this.dialog.saving = true;
            try {
                // Multipart por causa da imagem.
                const formData = new FormData();
                formData.append('title', form.title);
                formData.append('published_at', form.published_at);
                formData.append('content', form.content || '');
                if (this.dialog.imageFile) formData.append('image', this.dialog.imageFile);
                if (this.dialog.removeImage) formData.append('remove_image', '1');

                if (this.dialog.editing) {
                    await axios.patch(`/api/admin/client-news/${this.dialog.editing.id}`, formData);
                    this.$dialog.notify.info('Notícia atualizada', { position: 'top-right', timeout: 2000 });
                } else {
                    await axios.post(`/api/admin/clients/${form.client_id}/news`, formData);
                    this.$dialog.notify.info('Notícia publicada', { position: 'top-right', timeout: 2000 });
                }
                this.dialog.open = false;
                this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
            } finally {
                this.dialog.saving = false;
            }
        },

        async deleteItem(item) {
            const proceed = await this.$dialog.confirm({
                text: `Deseja excluir a notícia "${item.title}"?`,
                title: 'Excluir notícia',
                actions: { false: 'Cancelar', true: 'Excluir' }
            });
            if (!proceed) return;

            try {
                await axios.delete(`/api/admin/client-news/${item.id}`);
                this.$dialog.notify.info('Notícia excluída', { position: 'top-right', timeout: 2000 });
                this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
            }
        },
    },
};
</script>
